import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';

import { App } from './routes/App/App';

import './styles/main.scss';
import './i18n';

ReactDOM.render(<App />, document.getElementById('root'));
